const e = {
  "pipeline-lane-header": "pipeline-lane-header",
  "pipeline-lane-header__count": "pipeline-lane-header__count",
  "pipeline-lane-header__label": "pipeline-lane-header__label",
  "pipeline-lane-header__label--short": "pipeline-lane-header__label--short",
  "pipeline-lane-header__label--full": "pipeline-lane-header__label--full"
};
export {
  e as default
};
